import { useCallback } from 'react';
import { Box, SimpleGrid, Stack } from '@mantine/core';

import { Button, NumberInput, Select, Text, Textarea, YesNoRadioButton } from 'components';
import { CreditRequestStep } from 'types';
import { AppConstants } from '../../../../constants';
import CreditRequestExpenses from './outcome/expenses';

const { CREDIT_REQUEST_FORM_PADDING } = AppConstants;

const OutcomeInformationStep = ({
  form,
  isEditable,
  onSubmit,
  options,
  t,
}: CreditRequestStep) => {

  const onSubmitWrapper = useCallback(() => {
    if (isEditable && !isFormValid()) {
      return;
    }
    onSubmit();
  }, [isEditable, form.values, options]);

  const isFormValid = useCallback(() => {
    let isValid = true;
    return isValid;
  }, [form.values, options]);

  return (
    <SimpleGrid cols={{ base: 1, md: 2 }}>
      <Stack p={CREDIT_REQUEST_FORM_PADDING}>
        <Select
          label={t('input.houseSituation.label')}
          data={options['houseSituation'].map(el => (
            { value: el, label: t(`input.houseSituation.options.${el}`) }
          ))}
          key={form.key('houseSituation')}
          {...form.getInputProps('houseSituation')}
          clearable={true}
          disabled={!isEditable}
        />
        <YesNoRadioButton
          label={t('input.mortgage.label')}
          name={'mortgage'}
          form={form}
          t={t}
          disabled={!isEditable}
        />
        {form.values.mortgage ?
          <NumberInput
            label={t('input.mortgageAmount.label')}
            key={form.key('mortgageAmount')}
            {...form.getInputProps('mortgageAmount')}
            min={0}
            rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
            rightSectionWidth={40}
            disabled={!isEditable}
          />
        : undefined}
        <YesNoRadioButton
          label={t('input.rent.label')}
          name={'rent'}
          form={form}
          t={t}
          disabled={!isEditable}
        />
        {form.values.rent ?
          <NumberInput
            label={t('input.rentAmount.label')}
            key={form.key('rentAmount')}
            {...form.getInputProps('rentAmount')}
            min={options['rentAmount']?.min}
            max={options['rentAmount']?.max}
            rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
            rightSectionWidth={40}
            disabled={!isEditable}
          />
        : undefined}
        <NumberInput
          label={t('input.healthInsuranceAmount.label')}
          key={form.key('healthInsuranceAmount')}
          {...form.getInputProps('healthInsuranceAmount')}
          rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
          rightSectionWidth={40}
          disabled={!isEditable}
        />
        <YesNoRadioButton
          label={t('input.healthInsuranceDiscount.label')}
          name={'healthInsuranceDiscount'}
          form={form}
          t={t}
          disabled={!isEditable}
        />
      </Stack>
      <Stack p={CREDIT_REQUEST_FORM_PADDING}>
        <CreditRequestExpenses form={form} options={options} t={t} disabled={!isEditable} />
        <Textarea
          label={t('input.comment.label')}
          key={form.key('comment3')}
          {...form.getInputProps('comment3')}
          info={t('input.comment.info.message')}
          disabled={!isEditable}
        />
        <Button onClick={onSubmitWrapper}>
          {t(`action.${isEditable ? 'submitRequest' : 'goToDocumentation'}`)}
        </Button>
      </Stack>
    </SimpleGrid>
  )
}

export default OutcomeInformationStep;